import React from 'react'
import { IoLogoAndroid } from "react-icons/io5";
import { FaApple, FaWindows } from 'react-icons/fa6';

function Webinars() {
    const downloadLinks = {
        android: "https://play.google.com/store",
        windows: "https://www.microsoft.com/store",
        mac: "https://www.apple.com/mac",
        apple: "https://www.apple.com/app-store",
    };

    return (
        <>
            {/* <PageHeading title={'Webinars'} imgUrl={'https://th.bing.com/th/id/OIP.XPPVLT70UnEfK1cyms-zDwHaEK?w=900&h=506&rs=1&pid=ImgDetMain'} alt={'About'} /> */}
            <div className="min-h-screen/2 bg-gray-100 flex items-center justify-center p-10">
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                    <h1 className="text-2xl font-bold text-center mb-6">Download Apps</h1>

                    {/* Icons Section */}
                    <div className="flex flex-col gap-y-10 justify-around mb-8">
                        <div className="flex flex-col items-center border-b-2 pb-10">
                            <div className='flex flex-col items-center'>
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/9/9b/Google_Meet_icon_%282020%29.svg"
                                    alt="Google Meet"
                                    className="w-12 h-12 mb-2"
                                />
                                <span className="text-sm">Google Meet</span>
                            </div>
                            <div className='flex gap-2 items-center mt-4'>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://workspace.google.com/products/meet/', "_blank")}
                                ><FaWindows /></button>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://apps.apple.com/us/app/google-meet/id1096918571', "_blank")}
                                ><FaApple /></button>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://play.google.com/store/search?q=meet&c=apps&hl=en_US', "_blank")}
                                ><IoLogoAndroid /></button>
                            </div>
                        </div>
                        <div className="flex flex-col items-center border-b-2 pb-10">
                            <div className='flex flex-col items-center'>
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Microsoft_Office_Teams_%282018%E2%80%93present%29.svg/120px-Microsoft_Office_Teams_%282018%E2%80%93present%29.svg.png"
                                    alt="Microsoft Teams"
                                    className="w-12 h-12 mb-2"
                                />
                                <span className="text-sm">Microsoft Teams</span>
                            </div>
                            <div className='flex gap-2 items-center mt-4'>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://www.microsoft.com/en-us/microsoft-teams/download-app', "_blank")}
                                ><FaWindows /></button>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://apps.apple.com/us/app/microsoft-teams/id1113153706', "_blank")}
                                ><FaApple /></button>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://play.google.com/store/apps/details/Microsoft_Teams?id=com.microsoft.teams&hl=en_US', "_blank")}
                                ><IoLogoAndroid /></button>
                            </div>
                        </div>
                        <div className="flex flex-col items-center border-b-2 pb-10">
                            <div className='flex flex-col items-center'>

                                <img
                                    src="https://bpb-us-w2.wpmucdn.com/sites.umassd.edu/dist/f/777/files/2020/03/Zoom-Icon-Large-transparent.png"
                                    alt="Zoom"
                                    className="w-12 h-12 mb-2"
                                />
                                <span className="text-sm">Zoom</span>
                            </div>
                            <div className='flex gap-2 items-center mt-4'>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://zoom.us/downloads', "_blank")}
                                ><FaWindows /></button>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://apps.apple.com/us/app/zoom-workplace/id546505307', "_blank")}
                                ><FaApple /></button>
                                <button className='p-2 bg-neutral-200 rounded'
                                    onClick={() => window.open('https://play.google.com/store/search?q=zoom&c=apps', "_blank")}
                                ><IoLogoAndroid /></button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Webinars